import GoogleMapReact from 'google-map-react';
import React from 'react';
import constants from '../../constants/shops';
import styled from 'styled-components';

const GoogleMapContainer = styled.div`
  height: ${props => props.height + 'px'};
  width: 100%;
`;
const API_KEY = 'AIzaSyDc1nqs71rp08lHZwAIPsUcHyH7T5B3lgY';

const GoogleMapComponent = ({ height, isRenderPolygon, mapState }) => {
  return (
    <>
      <GoogleMapContainer height={height}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: API_KEY }}
          defaultCenter={mapState.center}
          defaultZoom={mapState.zoom}
        >

          {isRenderPolygon && constants.coverageMarkers.map(marker => (
            <span
              className="icon map-pin-dark big"
              lat={marker.lat}
              lng={marker.lng}
              key={marker.lat + marker.lng}
            />
          ))}

          {!isRenderPolygon && constants.shopsMarkers.map(marker => (
            <span
              className="icon map-pin-dark big"
              lat={marker.lat}
              lng={marker.lng}
              key={marker.lat + marker.lng}
            />
          ))}

          {!isRenderPolygon && constants.easyPayOfficeMarkers.map(office => (
            <span
              className="icon easypay big"
              lat={office.marker.lat}
              lng={office.marker.lng}
              key={office.marker.lat + office.marker.lng}
            />
          ))}

        </GoogleMapReact>
      </GoogleMapContainer>
    </>
  );
}

export default GoogleMapComponent;
